import PropTypes from 'prop-types';
import { fileActions } from 'core/File';
import { useTheme } from 'styled-components';
import {
    Card,
    Container,
    IconButton,
    ImagePreview,
    Text
} from 'mol-ui';
import {
    Col,
    Row
} from 'reactstrap';
import React, { useState } from 'react';
import {
    isDocFile,
    isImageFile
} from 'shared/utils';
import {
    useArray,
    useDispatch,
    useSelector
} from 'hooks';

const FileList = ({
    allowDownload = true,
    files = [],
    inlineImagePreview = false,
    onDelete
}) => {

    const { dangerColor } = useTheme();
    const dispatch = useDispatch();
    const {
        downloading: fileDownloading
    } = useSelector('file');

    const [filePreview, setFilePreview] = useState(null);
    const [inlinePreviews, , { toggle: toggleInlinePreview }] = useArray([]);

    return (
        <>
            <ImagePreview
                active={ !!filePreview }
                alt={ filePreview?.name }
                url={ filePreview?.url }
                onToggle={ () => setFilePreview(null) }
            />
            <Row>
                {
                    files.map(file => {
                        const { id, name, type, url } = file;
                        const hasImagePreview = isImageFile(type);
                        const hasPDFPreview = isDocFile(type);
                        const isPreviewSelected = inlinePreviews.includes(id);

                        const handleVisibility = () => {
                            if (hasPDFPreview) return window.open(url, name);
                            if (!hasImagePreview) return;
                            if (inlineImagePreview) return toggleInlinePreview(id);
                            setFilePreview(file);
                        };

                        return (
                            <Col key={ `file-${ id }` } xs="12">
                                <Container flexDirection="row" margin="0px 0px 5px 0px" width="100%">
                                    {
                                        !fileDownloading && allowDownload &&
                                        <IconButton
                                            icon="download"
                                            margin="0px 5px 0px 0px"
                                            size={ 14 }
                                            onClick={ () => dispatch(fileActions.downloadFile({ id, name })) }
                                        />
                                    }
                                    {
                                        ((!fileDownloading && hasImagePreview && !isPreviewSelected) || hasPDFPreview) &&
                                        <IconButton
                                            icon="visibility"
                                            margin="0px 5px 0px 0px"
                                            size={ 14 }
                                            onClick={ handleVisibility }
                                        />
                                    }
                                    {
                                        isPreviewSelected &&
                                        <IconButton
                                            icon="visibility_off"
                                            margin="0px 5px 0px 0px"
                                            size={ 14 }
                                            onClick={ () => toggleInlinePreview(id) }
                                        />
                                    }
                                    {
                                        onDelete &&
                                        <IconButton
                                            color={ dangerColor }
                                            icon="delete"
                                            margin="0px 5px 0px 0px"
                                            size={ 14 }
                                            onClick={ () => onDelete('id', id) }
                                        />
                                    }
                                    <Text>
                                        { name }
                                    </Text>
                                </Container>
                                {
                                    inlineImagePreview && isPreviewSelected &&
                                    <Card overflowX="auto" overflowY="auto" padding="0px">
                                        <Container alignItems="center" width="100%">
                                            <img
                                                alt={ name }
                                                src={ url }
                                            />
                                        </Container>
                                    </Card>
                                }
                            </Col>
                        );
                    })
                }
            </Row>
        </>
    );
};

FileList.propTypes = {
    allowDownload: PropTypes.bool,
    files: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.number,
        name: PropTypes.string,
        url: PropTypes.string
    })),
    inlineImagePreview: PropTypes.bool,
    onDelete: PropTypes.func
};

export default FileList;
